import React from "react";
import { CommonButtonWrapper } from "../../styles/StyledComponents/CommonButtonWrapper";
import { CommonButtonProps } from "../interface";

const CommonButton: React.FC<CommonButtonProps> = ({
  variant = "contained",
  color = "primary",
  children,
  startIcon,
  endIcon,
  fullWidth = false,
  className = "",
  ...props
}) => {
  return (
    <CommonButtonWrapper
      fullWidth={fullWidth}
      className={`common_btn ${variant} ${color} ${className}`}
      {...props}
    >
      {startIcon && <i className="cmn_icon start_icon">{startIcon}</i>}
      {children}
      {endIcon && <i className="cmn_icon end_icon">{endIcon}</i>}
    </CommonButtonWrapper>
  );
};

export default CommonButton;
